/* SK Search - mini-galeria de imagenes + añadir al carrito en cards de resultados */
(function () {
  'use strict';

  /* Delegacion en el grid: pasar imagenes de la card al pulsar las flechas */
  function initGrid(grid) {
    if (grid.dataset.skSearchInit) return;
    grid.dataset.skSearchInit = 'true';

    grid.addEventListener('click', function (e) {
      /* Añadir al carrito */
      var cartBtn = e.target.closest('.sk-search__action-btn--cart');
      if (cartBtn) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = cartBtn.dataset.variantId;
        if (!variantId) return;
        if (cartBtn.classList.contains('sk-search__action-btn--loading')) return;
        cartBtn.classList.add('sk-search__action-btn--loading');

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            cartBtn.classList.remove('sk-search__action-btn--loading');
            if (data.status) {
              console.error('Error al añadir:', data.description || data.message);
              return;
            }
            cartBtn.classList.add('sk-search__action-btn--added');
            setTimeout(function () {
              cartBtn.classList.remove('sk-search__action-btn--added');
            }, 1500);

            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: variantId,
                data: { source: 'product-form-component', itemCount: 1 }
              }
            }));
          })
          .catch(function () {
            cartBtn.classList.remove('sk-search__action-btn--loading');
          });
        return;
      }

      var arrow = e.target.closest('.sk-search__img-arrow');
      if (!arrow) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = arrow.closest('.sk-search__image-wrapper');
      if (!wrapper) return;

      var imgs = wrapper.querySelectorAll('.sk-search__image');
      if (imgs.length < 2) return;

      var current = 0;
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].classList.contains('sk-search__image--active')) { current = i; break; }
      }

      var dir = arrow.classList.contains('sk-search__img-arrow--next') ? 1 : -1;
      var next = (current + dir + imgs.length) % imgs.length;

      imgs[current].classList.remove('sk-search__image--active');
      imgs[next].classList.add('sk-search__image--active');

      /* La flecha izquierda solo aparece si no estamos en la primera imagen */
      var prevBtn = wrapper.querySelector('.sk-search__img-arrow--prev');
      if (prevBtn) prevBtn.classList.toggle('sk-search__img-arrow--hidden', next === 0);
    });
  }

  /* Inicializar grids existentes */
  var grids = document.querySelectorAll('.sk-search__grid');
  for (var i = 0; i < grids.length; i++) initGrid(grids[i]);

  /* Reinicializar en el Customizer si se recarga la seccion */
  document.addEventListener('shopify:section:load', function (e) {
    var newGrids = e.target.querySelectorAll('.sk-search__grid');
    for (var j = 0; j < newGrids.length; j++) initGrid(newGrids[j]);
  });
})();
